export const en = {
  releaseNotes: `
#### New Feature: Clickable Follow-Up Questions

Getting the most out of our Fleet Assistant is now even easier!

We've introduced clickable follow-up questions that appear after each response. These suggested prompts help you continue the conversation with just one click, no need to type your next question.

##### Benefits
- **Get to relevant information faster**
- **Explore related topics effortlessly**
- **Discover additional insights and recommendations**
- **Enjoy a smoother, more intuitive chat experience**

Simply click a suggested question to dive deeper into the topic and keep the conversation flowing.

**Less typing. Faster answers. Better conversations. 🚀**
`,
  image: 'assets/images/release_notes_sample_en.png',
  fixesAndImprovements: ``,
};
